import {Component, MeshComponent, Property} from '@wonderlandengine/api';

/**
 * timeout-sign
 */
export class TimeoutSign extends Component {
    static TypeName = 'timeout-sign';
    /* Properties that are configurable in the editor */
    static Properties = {
        param: Property.float(1.0),
    };

    start() {
        this.meshObj = this.object.findByName('IconX')[0];
        this.mesh = this.meshObj.getComponent(MeshComponent);
    }

    onActivate() {
        this.time = 0;
        this.mesh.active = true;
    }
    onDeactivate() {
        this.mesh.active = false;
    }

    update(dt) {
        this.time += dt;
        const s = 1.0 + Math.sin(3 * this.time) * 0.25;
        this.meshObj.setScalingLocal([s, s, s]);
    }
}
